var _title, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": "whatsappTitle whatsappDesc",
    viewBox: "0 0 100 100"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Compartilhar no whatsapp")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M39.435 60.855c9.35 9.825 16.284 15.627 20.803 17.409 6.848 2.7 13.394.373 17.756-3.988 4.361-4.362 7.778-6.92-1.344-14.444-11.121-9.947-9.386-.046-15.532 1.844-3.27 1.214-8.06-1.695-14.368-8.727l-.095.095c-6.806-6.17-9.611-10.866-8.416-14.087 1.89-6.147 11.791-4.411 1.844-15.533-7.524-9.121-10.082-5.705-14.443-1.343-4.362 4.361-6.688 10.908-3.989 17.756 1.8 4.565 7.704 11.595 17.712 21.09l.072-.072zM27.942 92.306L0 99.856l8.585-26.199c-4.215-7.238-6.63-15.654-6.63-24.635C1.955 21.948 23.903 0 50.978 0 78.052 0 100 21.948 100 49.022c0 27.075-21.948 49.023-49.022 49.023a48.807 48.807 0 01-23.036-5.739z"
  })));
}

export default SvgWhatsapp;